<ion-menu content-id="main-content" menu-id="sideMenu">
  <div class="main-bg">
    <div class="menu-wrap" [class.bg-image]="bgImage"
      [style.background-image]="sideMenuImage?'url('+sideMenuImage+')':''" [class.icon-list]="iconList">
      <ion-header class="ion-no-border">
        <ion-toolbar style="--background: none">
          <ion-title style="text-align: center;">
            <!-- Menu Header -->
            <!-- <ion-img class="title-image" [src]="logoUrl"></ion-img> -->
            <b><u>MATEO69</u></b>
          </ion-title>
          <!-- <span>Logged in as</span>
        <p> {{(menu?.menuTitle)}}</p> -->
        </ion-toolbar>
      </ion-header>
      <ion-content style="--background: none; --offset-bottom: -70px;">
        <ion-list id="inbox-list" lines="none">
          <ion-menu-toggle auto-hide="false" *ngFor="let p of (menu?.appPages | async); let i = index">
            <ion-item *ngIf="isMenuAvailable(p)" (click)="navigateToModule(p, i)" routerDirection="root" detail="false"
              [class.active]="menu?.selectedIndex == i">
              <span class="list-before"></span>
              <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <!-- <ion-button class="text-tert-tint" *ngIf="authService.isLoggedIn" (click)="menuCtrl.close()"
          routerLink="/profile" expand="block" fill="clear" shape="round">
          {{systemLanguage | async | systemLanguages:routeId:'profile'}}
        </ion-button> -->
        <ion-button class="text-tert-tint" (click)="logout();menuCtrl.close()" expand="block" fill="clear"
          shape="round">
          {{systemLanguage | async | systemLanguages:routeId:'module_button_logout'}}</ion-button>
        <!-- <ion-button size="small" (click)="logout()" color="secondary" style="position: absolute; right: 0; top: 0;">
          logout
        </ion-button> -->
        <!-- <ion-button class="text-tert-tint" *ngIf="isLoginInMenu && !authService.isLoggedIn" (click)="menuCtrl.close()"
          routerLink="/login" expand="block" fill="clear" shape="round">
          {{systemLanguage | async | systemLanguages:routeId:'module_button_login'}}
        </ion-button> -->
        <!--<ion-button *ngIf="isLoginOnStart" (click)="logout()" expand="block" fill="clear" shape="round">
        logout
      </ion-button>-->
        <div class="app-version">
          <span>{{version}}</span>
        </div>
      </ion-content>
      <div>
        <!-- <ion-select class="select-lng" (ionChange)="changeSystemLanguage($event)" placeholder="Select Language"
          value="{{selectedLanguageKey}}">
          <ion-select-option *ngFor="let l of (menu?.languageList | async);" value="{{l.key}}"
            selected="selectedLanguageKey == l.key">{{l.name}}</ion-select-option>
        </ion-select> -->
        <ion-select class="select-lng" *ngIf="lstLanguage&&lstLanguage.length > 1" mode="ios"
          (ionChange)="changeSystemLanguage($event)" [okText]="systemLanguage | async | systemLanguages:routeId:'_okay'"
          [cancelText]="systemLanguage | async | systemLanguages:routeId:'_cancel_prmpt'"
          placeholder="{{systemLanguage | async | systemLanguages:routeId:'select_language'}}"
          [value]="selectedLanguageKey">
          <ion-select-option *ngFor="let l of lstLanguage;" value="{{l.key}}" selected="selectedLanguageKey == l.key">
            {{l.name}}</ion-select-option>
        </ion-select>
      </div>
    </div>
  </div>

</ion-menu>